import React from 'react';

export const Profile = () => {
  return (
    <>
      Profile page
    </>
  )
}